import styled from 'styled-components'
import type { CompositionConfig } from '../config'
import { CSSProperties } from "react"

const Title = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-self: stretch;
  word-break: 'break-word';
`
const Subtitle = styled.div`
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: left;
  color: inherit;
  padding: 0;
  width: inherit;
  word-break: 'break-word';
`
const Preface = styled.div`
  letter-spacing: 0.005em;
  width: inherit;
  color: #808080;
  padding: 0;
`
const Line = styled.pre`
  white-space: pre-wrap;
  margin: 0;
`
const EmptyLine = styled.pre<{ height: CSSProperties['height'], fontFamily: CSSProperties['fontFamily'] }>`
  height: ${props => props.height};
  margin: 0;
  font-family: ${props => props.fontFamily};
`

export type PoemProps = {
  title: string,
  poem: string,
  subtitle?: string,
  preface?: string,
  config: CompositionConfig
}

export const Poem: React.FC<PoemProps> = ({ title, poem, subtitle = '', preface = '', config }) => {
  // Normalize potential null values coming from upstream (server request JSON etc.)
  subtitle = subtitle || ''
  preface = preface || ''
  const { textMaxWidth, innerEmptyLineHeightPX, innerLineStyle, titleStyle, subtitleStyle, prefaceStyle }: CompositionConfig = config

  const ptext = poem.split('\n').map((line, index) => {
    return /^\s*$/.test(line)
      ? <EmptyLine key={index} height={innerEmptyLineHeightPX} fontFamily={innerLineStyle.fontFamily}><br /></EmptyLine>
      : <Line key={index} style={innerLineStyle}>{line}</Line>
  })

  return (
    <div id="poem" style={{
      color: innerLineStyle.color,
      maxWidth: `${textMaxWidth}px`,
    }}>
      <Title id="title" style={titleStyle}>{title}</Title>
      {
        (subtitle || preface) ?
          <div style={{
            marginBottom: '58px',
          }}>
            {subtitle ? (
              <Subtitle id="subtitle" style={subtitleStyle}>{subtitle}</Subtitle>
            ) : null}

            {preface ? (
              <Preface id="preface" style={prefaceStyle}>{preface.split('\n').map((line, index) => (
                <Line key={index} style={{ margin: '0', fontFamily: prefaceStyle.fontFamily }}>{line}</Line>
              ))}
              </Preface>
            ) : null}
          </div> : <></>
      }
      <div id="main-text" style={{
        paddingBottom: '0',
        wordBreak: 'break-word',
      }}>
        <div>
          {ptext}
        </div>
      </div>
    </div>
  )
}
